// @flow

import { capitalize } from 'lodash';

const toRoleOption = (role: ?string) =>
  role
    ? {
        label: capitalize(role),
        value: role,
      }
    : null;

export default toRoleOption;
